/**
 * TargetPlatform
 *
 * Mirrors Flutter's framework `TargetPlatform` enum
 * (`package:flutter/foundation.dart`, Flutter 3.38.9 `platform.dart:65-83`) by
 * ordinal. The integer ordinal is the stored `user.platform` field (see Flutter
 * `user.dart:85` -> `int? platform`), and the displayed suffix is the Dart enum
 * member's `.name` string. The framework's exact ordinal order is
 * `android(0), fuchsia(1), iOS(2), linux(3), macOS(4), windows(5)`.
 *
 * Source: lib/presentation/screens/user/widgets/latest_users_list_item.dart:56-62
 * (`if (user.platform != null && user.platform != -1) Text(" - ${TargetPlatform.values[user.platform!].name}")`).
 *
 * The resolved names are user-visible platform identifiers (proper nouns that
 * match Flutter's raw enum `.name`); they are deliberately NOT l10n keys.
 * Flutter shows the locale-independent enum name verbatim, so we replicate it
 * exactly rather than routing through translatable copy.
 */
export enum TargetPlatform {
  ANDROID = 0,
  FUCHSIA = 1,
  IOS = 2,
  LINUX = 3,
  MACOS = 4,
  WINDOWS = 5,
}

/**
 * Dart `.name` string for each `TargetPlatform` ordinal, in Flutter's exact
 * order. Indexed directly by the stored `user.platform` integer.
 */
const TARGET_PLATFORM_NAMES: readonly string[] = [
  'android', // TargetPlatform.ANDROID
  'fuchsia', // TargetPlatform.FUCHSIA
  'iOS', // TargetPlatform.IOS
  'linux', // TargetPlatform.LINUX
  'macOS', // TargetPlatform.MACOS
  'windows', // TargetPlatform.WINDOWS
];

/**
 * Resolve the Flutter `TargetPlatform.values[platform].name` string for a
 * stored platform ordinal, mirroring `latest_users_list_item.dart:56-62`.
 *
 * Returns `null` when `platform == null` or `platform === -1` (Flutter's guard
 * suppresses exactly those). Defensive divergence: Flutter would throw a
 * `RangeError` for an ordinal outside `0..5`; on web we return `null` instead
 * of throwing, so the row simply omits the suffix for malformed data. For every
 * valid ordinal the visible behaviour is identical to Flutter.
 */
export function getTargetPlatformName(
  platform: number | null | undefined,
): string | null {
  if (platform == null || platform === -1) {
    return null;
  }
  return TARGET_PLATFORM_NAMES[platform] ?? null;
}
